import { makeStyles } from '@material-ui/core/styles';
import { designTokens } from '../../styles/designTokens';

export const useStyles = makeStyles({
    root: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    scrollWrapper: {
        position: 'relative',
        flex: 1,
        width: '100%',
    },
    scrollContent: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: 'auto',
        scrollbarWidth: 'none',
        padding: `0 ${designTokens.spacing.lg} ${designTokens.spacing.lg}`,
        '@media (max-width: 640px)': {
            padding: `0 ${designTokens.spacing.sm} ${designTokens.spacing.sm}`,
        },
    },
    tableContainer: {
        width: '100%',
        maxWidth: '1200px',
        margin: '0 auto',
    },
    table: {
        width: '100%',
        borderCollapse: 'separate',
        borderSpacing: 0,
        border: '1px solid #E5E7EB',
        borderRadius: designTokens.borderRadius.modal,
    },
    tableHead: {
        '& th': {
            ...designTokens.typography.tableHeader,
            backgroundColor: designTokens.colors.primary,
            padding: `${designTokens.spacing.md} ${designTokens.spacing.lg}`,
            textAlign: 'left',
            whiteSpace: 'nowrap',
            borderBottom: '1px solid #E5E7EB',
            position: 'sticky',
            top: 0,
            zIndex: 1,
            '@media (max-width: 600px)': {
                padding: `${designTokens.spacing.sm} ${designTokens.spacing.sm}`,
            },
            '&:first-child': {
                borderTopLeftRadius: designTokens.borderRadius.modal,
            },
        },
    },
    thUserData: {
        width: '30%',
        '@media (max-width: 900px)': {
            width: '35%',
        },
        '@media (max-width: 600px)': {
            width: 'auto',
        },
    },
    thResearch: {
        width: '40%',
        '@media (max-width: 900px)': {
            width: '35%',
        },
        '@media (max-width: 600px)': {
            display: 'none',
        },
    },
    thPrice: {
        width: '15%',
        textAlign: 'center !important',
        '@media (max-width: 900px)': {
            width: '15%',
        },
        '@media (max-width: 600px)': {
            display: 'none',
        },
    },
    thTotal: {
        width: '15%',
        textAlign: 'center !important',
        '@media (max-width: 900px)': {
            width: '15%',
        },
        '@media (max-width: 600px)': {
            width: '1px',
            whiteSpace: 'nowrap',
        },
    },
    tableBody: {
        '& tr': {
            borderBottom: '1px solid #E5E7EB',
            '&:last-child td': {
                '&:first-child': {
                    borderBottomLeftRadius: designTokens.borderRadius.modal,
                },
                '&:last-child': {
                    borderBottomRightRadius: designTokens.borderRadius.modal,
                },
            },
        },
        '& td': {
            padding: `${designTokens.spacing.lg} ${designTokens.spacing.lg}`,
            verticalAlign: 'top',
            borderBottom: '1px solid #E5E7EB',
            '@media (max-width: 600px)': {
                padding: `${designTokens.spacing.md} ${designTokens.spacing.sm}`,
            },
        },
    },
    userDataCell: {
        '& p': {
            margin: 0,
            fontFamily: designTokens.fontFamily,
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '24px',
            letterSpacing: '-0.31px',
            color: '#1E2939',
        },
    },
    userDataLabel: {
        fontWeight: '500 !important',
    },
    researchCell: {
        '& p': {
            margin: 0,
            fontFamily: designTokens.fontFamily,
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '24px',
            letterSpacing: '-0.31px',
            color: '#1E2939',
        },
        '@media (max-width: 600px)': {
            display: 'none',
        },
    },
    serviceRow: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'baseline',
        marginBottom: designTokens.spacing.xs,
        '&:last-child': {
            marginBottom: 0,
        },
    },
    priceCell: {
        textAlign: 'center',
        '& p': {
            margin: 0,
            fontFamily: designTokens.fontFamily,
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '24px',
            letterSpacing: '-0.31px',
            color: '#1E2939',
            marginBottom: designTokens.spacing.xs,
            '&:last-child': {
                marginBottom: 0,
            },
        },
        '@media (max-width: 600px)': {
            display: 'none',
        },
    },
    totalPriceCell: {
        textAlign: 'center',
        verticalAlign: 'middle !important',
        '& p': {
            margin: 0,
            fontFamily: designTokens.fontFamily,
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '24px',
            letterSpacing: '-0.31px',
            color: '#1E2939',
        },
        '@media (max-width: 600px)': {
            width: '1px',
            whiteSpace: 'nowrap',
        },
    },
    mobileRow: {
        '@media (max-width: 600px)': {
            cursor: 'pointer',
        },
    },
    mobileRowExpanded: {
        '& td': {
            borderBottom: 'none !important',
        },
    },
    chevronCell: {
        width: '1px',
        whiteSpace: 'nowrap',
        verticalAlign: 'middle !important',
        textAlign: 'center',
        padding: `${designTokens.spacing.sm} !important`,
    },
    chevronCellHead: {
        width: '1px',
        whiteSpace: 'nowrap',
        borderTopRightRadius: `${designTokens.borderRadius.modal} !important`,
    },
    thAction: {
        width: '1px',
        whiteSpace: 'nowrap',
    },
    actionCell: {
        width: '1px',
        whiteSpace: 'nowrap',
        verticalAlign: 'middle !important',
        textAlign: 'center',
        padding: `${designTokens.spacing.sm} !important`,
    },
    deleteButton: {
        padding: '4px',
    },
    deleteIcon: {
        color: designTokens.colors.red.main,
        fontSize: '20px',
    },
    cancelledCell: {
        textAlign: 'right',
        verticalAlign: 'middle !important',
    },
    cancelledText: {
        margin: 0,
        fontFamily: designTokens.fontFamily,
        fontSize: '16px',
        fontWeight: 500,
        lineHeight: '24px',
        letterSpacing: '-0.31px',
        color: designTokens.colors.red.main,
        '@media (max-width: 600px)': {
            fontSize: '14px',
            lineHeight: '20px',
        },
    },
    chevron: {
        display: 'inline-block',
        width: '8px',
        height: '8px',
        borderRight: `2px solid ${designTokens.colors.grey[400]}`,
        borderBottom: `2px solid ${designTokens.colors.grey[400]}`,
        transform: 'rotate(45deg)',
        transition: 'transform 0.2s ease',
    },
    chevronOpen: {
        transform: 'rotate(-135deg)',
    },
    accordionRow: {},
    accordionHidden: {
        display: 'none !important',
    },
    accordionContent: {
        padding: `0 ${designTokens.spacing.lg} ${designTokens.spacing.lg} !important`,
        borderBottom: '1px solid #E5E7EB',
    },
    accordionTitle: {
        margin: `0 0 ${designTokens.spacing.sm}`,
        fontFamily: designTokens.fontFamily,
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: '20px',
        letterSpacing: '-0.31px',
        color: '#1E2939',
    },
    accordionServiceRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        marginBottom: designTokens.spacing.xs,
        '&:last-child': {
            marginBottom: 0,
        },
        '& p': {
            margin: 0,
            fontFamily: designTokens.fontFamily,
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '20px',
            letterSpacing: '-0.31px',
            color: '#1E2939',
        },
    },
    accordionServicePrice: {
        flexShrink: 0,
        marginLeft: designTokens.spacing.md,
    },
    accordionServicesSection: {
        '@media (min-width: 601px)': {
            display: 'none',
        },
    },
    noteSection: {
        marginTop: designTokens.spacing.md,
        '@media (min-width: 601px)': {
            marginTop: 0,
        },
    },
    noteText: {
        margin: 0,
        fontFamily: designTokens.fontFamily,
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '20px',
        letterSpacing: '-0.31px',
        color: '#1E2939',
    },
    rowWithNote: {
        cursor: 'pointer',
    },
    chevronDesktopHidden: {
        '@media (min-width: 601px)': {
            visibility: 'hidden',
        },
    },
    dialogErrorText: {
        ...designTokens.typography.error,
        textAlign: 'center',
        padding: designTokens.spacing.lg,
    },
    emptyStateWrapper: {
        width: '100%',
        maxWidth: '1200px',
        margin: '0 auto',
        border: `1px solid ${designTokens.colors.border}`,
        borderRadius: designTokens.borderRadius.card,
        minHeight: '400px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: designTokens.spacing.xxxl,
        textAlign: 'center',
    },
    emptyStateTitle: {
        fontFamily: designTokens.fontFamily,
        fontSize: '18px',
        fontWeight: 500,
        lineHeight: '24px',
        color: '#1E2939',
        margin: `0 0 ${designTokens.spacing.sm}`,
    },
    emptyStateSubtitle: {
        ...designTokens.typography.subtitle,
        margin: 0,
    },
});
